<template>
  <div class="column-picker" ref="pickerRef">
    <button
      class="button button--filter column-picker__toggle"
      :aria-expanded="isOpen"
      :aria-controls="menuId"
      @click="togglePicker">
      <span>Välj kolumner</span>
      <span class="column-picker__icon icon icon--arrow-down" :class="{ 'column-picker__icon--open': isOpen }" aria-hidden="true"></span>
    </button>
    <div :id="menuId" class="column-picker__menu" v-show="isOpen">
      <div class="column-picker__head">
        <h3>Välj kolumner</h3>
        <Cross @click="closePicker" />
      </div>
      <ClearButton v-if="anyVisible" @click="clearAll" />
      <ul>
        <li v-for="(config, dataKey) in computedColumnConfig" :key="dataKey">
          <CheckBox :id="`${idPrefix}-${dataKey}-checkbox`" v-model="config.visible" :label="config.displayName" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, PropType, ref } from 'vue';
import CheckBox from '../checkbox/CheckBox.vue';
import ClearButton from '@/components/clear/ClearButton.vue';
import Cross from '../cross/Cross.vue';

const props = defineProps({
  columnConfig: {
    type: Object as PropType<{ [key: string]: { displayName: string; visible: boolean } }>,
    required: true,
  },
  idPrefix: {
    type: String,
    default: 'column-picker',
  },
});

const isOpen = ref(false);
const computedColumnConfig = computed(() => props.columnConfig);
const menuId = computed(() => `${props.idPrefix}-menu`);
const pickerRef = ref<HTMLElement | null>(null);

const anyVisible = computed(() => {
  return Object.values(props.columnConfig).some(config => config.visible);
});

const clearAll = () => {
  Object.values(props.columnConfig).forEach(config => config.visible = false);
};

const togglePicker = () => {
  isOpen.value = !isOpen.value;
};

const closePicker = () => {
  isOpen.value = false;
};

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as Node | null;
  if (target && pickerRef.value && !pickerRef.value.contains(target)) {
    closePicker();
  }
};

const handleEscape = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    closePicker();
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside, true);
  document.addEventListener('keydown', handleEscape);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside, true);
  document.removeEventListener('keydown', handleEscape);
});

</script>
